export const easing = [0.22, 1, 0.36, 1];

export const duration = {
    fast: 0.35,
    normal: 0.5,
    slow: 0.7,
};

export const transition = {
    duration: duration.normal,
    ease: easing,
};

export const viewport = {
    once: true,
    margin: "-80px",
    amount: 0.15,
};

export const fadeUp = {
    hidden: { opacity: 0, y: 24 },
    visible: { opacity: 1, y: 0 },
};

export const fadeIn = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
};

export const staggerContainer = {
    hidden: {},
    visible: {
        transition: {
            staggerChildren: 0.08,
            delayChildren: 0.05,
        },
    },
};

export const pageTransition = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { duration: 0.2, ease: easing },
};
